"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = exports._Modal = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("@emotion/react");

var react_2 = require("react");

var components_utils_1 = require("@conte-ltd/components-utils");

var overlays_1 = require("@react-aria/overlays");

var dialog_1 = require("@react-aria/dialog");

var interactions_1 = require("@react-aria/interactions");

var overlay_container_1 = require("./overlay-container");

function _Modal(props, fwRef) {
  var children = props.children;
  var context = (0, react_2.useContext)(overlay_container_1.OverlayContext);
  (0, components_utils_1.assertIsDefined)(context, 'ModalコンポーネントはOverlayContainerコンポーネントの配下に存在する必要があります');
  var onClose = context.onClose,
      overlayProps = context.overlayProps,
      ref = context.ref;
  var modalProps = (0, overlays_1.useModal)(props).modalProps;
  var dialogProps = (0, dialog_1.useDialog)(props, ref).dialogProps;
  var pressProps = (0, interactions_1.usePress)(props).pressProps;
  return (0, jsx_runtime_1.jsxs)("div", __assign({
    css: (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        position: fixed;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        background: white;\n        &:focus {\n          outline: 0;\n        }\n      "], ["\n        position: fixed;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        background: white;\n        &:focus {\n          outline: 0;\n        }\n      "]))),
    ref: (0, components_utils_1.mergeRefs)([ref, fwRef])
  }, (0, components_utils_1.mergeProps)(overlayProps, dialogProps, modalProps, pressProps, (0, components_utils_1.styleProps)(props)), {
    children: [children, (0, jsx_runtime_1.jsx)(overlays_1.DismissButton, {
      onDismiss: onClose
    }, void 0)]
  }), void 0);
}

exports._Modal = _Modal;
exports.Modal = (0, react_2.forwardRef)(_Modal);
var templateObject_1;